/** User-facing copy for the screen on which a signed-in user approves an MCP client's connection to CMS. */
export const TEXTS = {
  TITLE: 'Connect an MCP client',
  CLIENT_ASKS: (clientName: string, redirectHost: string): string =>
    `${clientName} at ${redirectHost} is asking to connect to Five Sigma CMS as you.`,
  /** Any client may register under any name, so only the host identifies where the approval goes. */
  CLIENT_NAME_UNVERIFIED: (redirectHost: string): string =>
    `The client chose this name itself and Five Sigma has not verified it. Approve only if you started this connection and trust ${redirectHost}.`,
  /** A loopback redirect hands the code to whatever program on this computer listens on that port, under any name. */
  LOOPBACK_REDIRECT:
    'Approving sends access to a program running on this computer. Approve only if you just started this connection from your own MCP client.',
  SIGNED_IN_AS: (userEmail: string): string => `Signed in as ${userEmail}`,
  SCOPES_TITLE: 'Approving lets it:',
  REQUIRED_SCOPE: (scope: string): string => `${scope} (required)`,
  RETURNS_TO: (redirectHost: string): string => `Approving or denying will return you to ${redirectHost}.`,
  APPROVE: 'Approve',
  DENY: 'Deny',

  /** The consent API's 400: the request expired, or was never signed by this server. */
  REQUEST_EXPIRED: 'This connection request expired. Start the connection again from your MCP client.',
  /** The consent API's 403: only super-organization users, signed in as themselves, may approve a client. */
  STAFF_ONLY: 'Only Five Sigma staff can connect an MCP client, and not while viewing CMS as another user.',
  /** Shown instead of the form inside a frame, where another site could have the user approve unseen. */
  FRAMED: 'Open this page in a browser tab of its own to connect an MCP client.',
};
